/**
 * De maandafkortingen, van ons en niet van het apparaat.
 *
 * Regel voor regel dezelfde tabel als MAANDEN in DetailLabels.kt op Android.
 *
 * Waarom dit bestaat: `toLocaleDateString("nl-NL", { month: "short" })` leest
 * de afkorting uit de ICU-gegevens van de browser, en die komen mee met het
 * besturingssysteem. Aan de Android-kant liep dezelfde afhankelijkheid via de
 * CLDR-gegevens van de JVM, en daar viel het door de mand: op de bouwstraat
 * (JDK 17) faalden precies de drie tests die een maand afdrukken, terwijl ze op
 * JDK 21 alle drie slaagden. Sommige versies zetten er een punt achter, andere
 * niet.
 *
 * En het scheelde de twee apps al: Android schreef "12 aug 20:51", de mini app
 * "12 aug, 18:51" — een komma erbij, uit dezelfde soort tabel die we niet in de
 * hand hadden.
 *
 * Twaalf woorden zijn geen last om zelf te bewaren.
 */
const MAANDEN = ["jan", "feb", "mrt", "apr", "mei", "jun",
                 "jul", "aug", "sep", "okt", "nov", "dec"];

/** "12 aug" — dag en maand, zonder de spelling van het apparaat te vragen. */
export const dagMaand = (d) => `${d.getDate()} ${MAANDEN[d.getMonth()]}`;

/** "20:51" — cijfers, met de voorloopnul die een klok hoort te hebben. */
export const uurMinuut = (d) =>
  `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
